import React, { useContext } from 'react';
import { Redirect } from 'react-router-dom';

import './styles.scss';

import { Context } from 'context/AuthContext';
import HeaderApp from 'components/Header/HeaderApp';
import Bottom from 'components/Bottom';
import ContentPendenciaDemanda from './ContentPendeciaDemanda';

const Pendencias = () => {
  const { userData } = useContext(Context);

  if (userData.siglaTipo == 'COOR') {
    return <Redirect to="/PaginaNaoEncontrada" />;
  }
  else {
    return (
      <>
        <HeaderApp />
        <ContentPendenciaDemanda />
        <Bottom />
      </>
    );
  }
};

export default Pendencias;
